import script from "./LightGroupMsgItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./LightGroupMsgItem.vue?vue&type=script&setup=true&lang=ts"

import "./LightGroupMsgItem.vue?vue&type=style&index=0&id=5ae449f4&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ae449f4"]])

export default __exports__